import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-4" }
const _hoisted_2 = {
  class: "text-xl text-primary",
  "data-testId": "session-time-left"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "data-testid": "session-timeout-modal",
    heading: _ctx.$t('session-timeout.heading'),
    onCloseModel: _ctx.methods.closeModal
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('session-timeout.text')), 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.timeLeft), 1)
      ])
    ]),
    "action-buttons": _withCtx(() => [
      _createVNode(_component_Button, {
        "data-testid": "continue-session-button",
        text: _ctx.$t('session-timeout.continue'),
        theme: "full",
        onClick: _ctx.methods.closeModal
      }, null, 8, ["text", "onClick"]),
      _createVNode(_component_Button, {
        class: "mr-3",
        "data-testid": "logout-button",
        text: _ctx.$t('session-timeout.logout'),
        onClick: _ctx.methods.logout
      }, null, 8, ["text", "onClick"])
    ]),
    _: 1
  }, 8, ["heading", "onCloseModel"]))
}